export default {
  'APP_SHIPMENT_UPDATE': 'APP_SHIPMENT_UPDATE',
  'APP_SHIPMENT_ADMIN': 'APP_SHIPMENT_ADMIN',
  'APP_PRODUCT_IDENTIFIER_UPDATE': 'APP_PRODUCT_IDENTIFIER_UPDATE',
  'APP_COMMERCE_VIEW': 'APP_COMMERCE_VIEW',
  'APP_UPDT_FULFILL_FORCE_SCAN_CONFIG': 'APP_UPDT_FULFILL_FORCE_SCAN_CONFIG',
  'APP_UPDT_RECEIVE_FLOW_CONFIG': 'APP_UPDT_RECEIVE_FLOW_CONFIG',
  'APP_PWA_STANDALONE_ACCESS': 'APP_PWA_STANDALONE_ACCESS'
}